import web2clientapi from '@wg/web2clientapi';
import { playSound } from "./base";

export const playDropdownSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'dropmenu_button',
    action: 'click'
  });
};

export const playOpenDialogSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_window',
    action: 'open'
  });
};

export const playCloseDialogSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_window',
    action: 'close'
  });
};

export const playInputSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_textinput',
    action: 'change'
  });
};

export const playCheckboxSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_checkbox',
    action: 'click'
  });
};

export const playButtonSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_button',
    action: 'press'
  });
};

export const playScreenChangeSound = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'default_screen',
    action: 'change'
  });
};

export const playClanBaseAmbient = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Clan_Base_Ambient',
    action: 'visible'
  });
};

export const stopClanBaseAmbient = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Stop_Clan_Base_Ambient',
    action: 'invisible'
  });
};

export const playClanBaseOver = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Clan_Base_Over',
    action: 'over'
  });
};

export const stopClanBaseOver = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Stop_Clan_Base_Over',
    action: 'out'
  });
};

export const playClanBaseBuilding = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Clan_Base_Building',
    action: 'click'
  });
};

export const playClanBaseSelect = () => {
  web2clientapi.sounds.playSound({
    soundsetName: 'Clan_Base_Select',
    action: 'click'
  });
};